export const getUrlMatches = (url: string, pattern: any) => {
  let match = url.match(pattern)
  if (match) {
    return match
  }
  let rawUrl = url.replace(/^https?:\/\//, '')
  match = rawUrl.match(pattern)
  if (match) {
    return match
  }
  rawUrl = rawUrl.replace(/^www\./, '')
  match = rawUrl.match(pattern)
  if (match) {
    return match
  }
  return null
}
